import { Component, inject, Inject, Input, OnInit } from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {RxwebValidators} from "@rxweb/reactive-form-validators";
import {RequesterService} from "../../common/services/requester.service";
import {NzMessageService} from "ng-zorro-antd/message";
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  init: boolean = false;
  changePasswordForm: FormGroup;
  isLoading = false;
  constructor(
    private fb: FormBuilder,
    private requesterService: RequesterService,
    private messageService: NzMessageService,
    @Inject(NZ_MODAL_DATA) private data: any,
    private nzModalRef: NzModalRef
  ) {
    console.log('DATA******',this.data);
    this.init = this.data?.init;
  }

  ngOnInit() {
    this.changePasswordForm = this.fb.group({
      password: ['', [Validators.required]],
      newPassword: ['', [Validators.required]],
      confirm_password: ['', [Validators.required, RxwebValidators.compare({fieldName: 'newPassword'})]]
    });
    if(this.init) {
      // remove the Required validator from password field
      this.changePasswordForm.get('password').clearValidators();
    }
  }

  changePassword() {
    if (!this.changePasswordForm.valid) {
      this.markFormGroupTouched(this.changePasswordForm);

    } else {
      this.isLoading = true;
      // console.log(this.changePasswordForm.value);
      this.requesterService.request('post', 'auth/change-password', { password: this.changePasswordForm.value.newPassword}).subscribe(changed => {
        // this.messageService.success('Password changed successfully!');
        this.messageService.success(`Password ${this.init ? 'set' : 'changed'} successfully!`);
        this.changePasswordForm.reset();
        this.isLoading = false;
        if(this.init) {
          this.nzModalRef.destroy();
        }
      }, error => {
        this.messageService.error(error.error.message);
        this.isLoading = false;
      })
    }

  }

  private markFormGroupTouched(formGroup: FormGroup) {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      control.markAsDirty();
      control.updateValueAndValidity();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

}
